import type { Tone } from '@/lib/tone'

export type Role = 'owner' | 'admin' | 'user' | 'viewer'

interface RoleInfo {
  label: string
  description: string
  tone: Tone
}

export const roleConfig: Record<Role, RoleInfo> = {
  owner: {
    label: 'Proprietário',
    description: 'Acesso total à plataforma',
    tone: 'progress'
  },
  admin: {
    label: 'Administrador',
    description: 'Acesso às configurações, sem gerenciar pagamentos',
    tone: 'info'
  },
  user: {
    label: 'Usuário',
    description: 'Acesso básico a cadastro e visualização',
    tone: 'success'
  },
  viewer: {
    label: 'Visualizador',
    description: 'Pode apenas visualizar',
    tone: 'warning'
  }
}

export const roleOptions: Role[] = ['owner', 'admin', 'user', 'viewer']

export interface PermissionGrant {
  resource: string
  level: 'read' | 'write' | 'delete'
}

export const CRM_TEAM_RESOURCE = 'crm-team'
export const CRM_TEAM_LABEL = 'Gestão do CRM'
export const CRM_TEAM_DESCRIPTION = 'Ver todos os negócios e configurar o funil'

export const roleIncludesCrmTeam = (role?: string | null): boolean => role === 'owner' || role === 'admin'

export const hasCrmTeamGrant = (permissions?: PermissionGrant[] | null): boolean =>
  (permissions ?? []).some(permission => permission.resource === CRM_TEAM_RESOURCE)

export const isCrmManager = (role?: string | null, permissions?: PermissionGrant[] | null): boolean =>
  roleIncludesCrmTeam(role) || hasCrmTeamGrant(permissions)

export function withCrmTeamGrant(permissions: PermissionGrant[] | null | undefined, enabled: boolean): PermissionGrant[] {
  const others = (permissions ?? []).filter(permission => permission.resource !== CRM_TEAM_RESOURCE)
  return enabled ? [...others, { resource: CRM_TEAM_RESOURCE, level: 'delete' }] : others
}
